/**
 * Deep links into the host's booking view, mirroring the meetings calendar's
 * {@link import("../meetings/shared").calendarLinkFor}. A booked slot on either calendar
 * links here: it opens the owning booking page and focuses the exact slot that was booked.
 */
export const FOCUS_PAGE_PARAM = "page";
export const FOCUS_SLOT_PARAM = "slot";

/** Open /booking-pages with a page expanded and one slot (by ISO start) focused. */
export function bookingLinkFor(bookingPageId: string, slotStartIso: string): string {
  const p = encodeURIComponent(bookingPageId);
  const s = encodeURIComponent(slotStartIso);
  return `/booking-pages?${FOCUS_PAGE_PARAM}=${p}&${FOCUS_SLOT_PARAM}=${s}`;
}

/**
 * The rolling appointment link to open in its builder, by id.
 *
 * <p>Its own half of the walk between a link and the availability pattern it owns: a pattern card
 * on the profile links here, and the builder links back at {@code availabilityPatternLinkFor}.</p>
 */
export const FOCUS_ROLLING_PARAM = "rolling";

/** Open /booking-pages with one rolling appointment loaded into its builder. */
export function rollingLinkLinkFor(rollingLinkId: string): string {
  return `/booking-pages?${FOCUS_ROLLING_PARAM}=${encodeURIComponent(rollingLinkId)}`;
}
